import React from 'react'
import { Flex, Spacer, Text } from '@sendoutcards/quantum-design-ui'
import { UnlockWithPhone } from '../components/UnlockWithPhone'

export const UnlockSendCode = (props: { username: string }) => {
  const { username } = props
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{ maxWidth: '500px', width: '100%' }}
    >
      <Spacer space="x4" />
      <Text type="title" alignment="center" weight="bold">
        Account Locked
      </Text>
      <Spacer space="x3" />
      <Text type="body" alignment="center">
        Your account has been locked due to too many unsuccessful login
        attempts. To unlock your account, we'll send a verification code to your
        registered phone number.
      </Text>
      <Spacer space="x4" />
      <UnlockWithPhone username={username} />
    </Flex>
  )
}
